import httpService from "@Utils/httpService";

const baseUrl = "api/Account";

export default {
  registerAndLogin(data) {
    return httpService.post({
      url: `${baseUrl}/RegisterAndLogin`,
      data,
    });
  },
  login(data) {
    return httpService.post({
      url: `${baseUrl}/Login`,
      data,
    });
  },
    self(data) {
    return httpService.get({
      url: `${baseUrl}/self`,
    });
  },
  // Fetches the currently authenticated user's profile. Unlike the login response
  // (which bypasses the BlobUrlSigningFilter because no JWT/company context is
  // available yet when the token is being issued), this endpoint is called with
  // a valid JWT, so the response's avatarUrl is properly SAS-signed.
  getCurrentUser() {
    return httpService.get({
      url: `api/User/CurrentUser`,
    });
  },
  checkCustomUI(url) {
    return httpService.post({
      url: `${baseUrl}/CheckCustomUI`,
      data: { url },
    });
  },
  forgotPassword(data) {
    return httpService.post({
      url: `${baseUrl}/ForgotPassword`,
      data,
    });
  },
  resetPassword(data) {
    return httpService.post({
      url: `${baseUrl}/resetPassword`,
      data,
    });
  },
   updatePassword(data) {
    return httpService.put({
      url: `${baseUrl}/updatePassword`,
      data,
    });
  },
  completeRegister(data) {
    return httpService.post({
      url: `${baseUrl}/CompleteRegister`,
      data,
    });
  },
  acceptEula(data) {
    return httpService.post({
      url: `${baseUrl}/AcceptEula`,
      data,
    });
  },
  getEulaStatus() {
    return httpService.get({
      url: `${baseUrl}/GetEulaStatus`,
    });
  },
  updateUserPreferences(data) {
    return httpService.put({
      url: `${baseUrl}/UpdateUserPreferences`,
      data,
    });
  },
};
